
import React, { useState, useEffect } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { MobileSidebar } from "../../chatMain/Sidebar/SidebarMobile";



export const Header = ({ title = "", subtitle = "", showBackButton = true, onBack }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480); // default mobile check

  const handleBackButton = () => {
    if (onBack) {
      onBack(); 
    } else {
      window.history.back(); 
    }
  };


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

    // Listen for window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 480) setSidebarOpen(false); // auto close if resized to desktop
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {/* Sidebar: shown only when sidebarOpen is true */}
      {sidebarOpen && <MobileSidebar onClose={() => setSidebarOpen(false)} />}

  
    <div className="Header-container">
      <div className="Header-left-icons">
    <div className="Header-hamburger"  onClick={toggleSidebar}>
      <FontAwesomeIcon icon={faBars} />
    </div>
    {showBackButton && (
        <div className="Header-backbutton-wrapper">
          <div className="Header-backbutton" onClick={handleBackButton}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
        </div>
      )}
      </div>
      <div className="Header-content-wrapper">
        <div className="Header-text-wrapper">
          <div className="Header-title">
            <p>{title}</p>
          </div>
          <div className="Header-subtitle">
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
